var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeeDoctor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1662542385962,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 47656,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M745.09 211.06H701.2V145.6c0-26.67-28.7-48.5-63.79-48.5H335.1c-35.09 0-63.79 21.83-63.79 48.5v65.46h-43.89c-63.36 0-115.2 51.84-115.2 115.2v430.77c0 63.37 51.84 115.21 115.2 115.21H745.1c63.36 0 115.21-51.84 115.21-115.21V326.25c-0.01-63.35-51.85-115.19-115.22-115.19zM644.66 582.13c-0.06 21.18-17.22 38.34-38.4 38.4h-54.23v54.26c-0.06 21.18-17.22 38.34-38.4 38.4h-54.71c-21.18-0.06-38.34-17.22-38.4-38.4v-54.26h-54.26c-21.17-0.08-38.3-17.23-38.36-38.4v-54.72c0.06-21.18 17.22-38.34 38.4-38.4h54.26v-54.23c0.06-21.18 17.22-38.34 38.4-38.4h54.68c21.18 0.07 38.33 17.22 38.39 38.4v54.27h54.26c21.16 0.08 38.29 17.21 38.37 38.36v54.72z m0.76-371.07H327.13v-38.22c0-17.74 19.14-32.33 42.53-32.33h233.2c23.39 0 42.53 14.55 42.53 32.33l0.03 38.22z",
    fill: "#ffffff",
    "p-id": 47657
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M911.78 795.83c-0.06 21.18-17.22 38.34-38.4 38.4h-54.23v54.26c-0.06 21.18-17.22 38.34-38.4 38.4h-54.71c-21.18-0.06-38.34-17.22-38.4-38.4v-54.26h-54.26c-21.17-0.08-38.3-17.23-38.36-38.4v-54.72c0.06-21.18 17.22-38.34 38.4-38.4h54.26v-54.23c0.06-21.18 17.22-38.34 38.4-38.4h54.68c21.18 0.07 38.33 17.22 38.39 38.4v54.27h54.26c21.16 0.08 38.29 17.21 38.37 38.36v54.72z",
    fill: "#ffffff",
    "p-id": 47658
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeDoctor);
export default __webpack_public_path__ + "static/media/seeDoctor.6c72a0f2.svg";
export { ForwardRef as ReactComponent };